import { css, keyframes } from 'styled-components'

export const animationEase = 'cubic-bezier(0.22, 1, 0.36, 1)'
export const animationFast = '600ms'
export const animationNormal = '900ms'
export const animationSlow = '1100ms'

export const reducedMotion = css`
    @media (prefers-reduced-motion: reduce) {
        animation: none !important;
        transition: none !important;
        transform: none !important;
    }
`

export const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

export const fadeSlideDown = keyframes`
    from {
        opacity: 0;
        transform: translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

export const scaleFadeIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.98);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`

export const fadeIn = keyframes`
    from { opacity: 0; }
    to { opacity: 1; }
`

export const flyInFromBottom = keyframes`
    from {
        opacity: 0;
        transform: translateY(50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`
